module.exports = __webpack_public_path__ + "static/media/Miracle Girls - Box Back.6bbfc88d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/box/Miracle Girls - Box Back.jpg
// module id = 94
// module chunks = 0